<template>
  
  <v-container fluid>

    <v-layout row my-3>
      <v-flex xs12 class="text-xs-center">
        <h1>Hi, {{ user.first_name }}</h1>
      </v-flex>
    </v-layout>

    <v-layout row my-3>
      <v-flex xs12>

        <v-tabs 
          fixed-tabs 
          v-model="tab"
          color="transparent"
        >
          <v-tabs-slider color="black"></v-tabs-slider>

          <v-tab exact :to="{name: 'account-trips'}">
            Trips
          </v-tab>
          <v-tab exact :to="{name: 'account-perks'}">
            Perks
          </v-tab>
          <v-tab :to="{name: 'account-profile'}">
            Profile
          </v-tab>
        </v-tabs>

      </v-flex>
    </v-layout>

    <transition name="fade-up" mode="out-in" appear>
      <router-view></router-view>
    </transition>
  </v-container>

</template>

<script>

export default {
  name: 'Account',
  data () {
    return {
      tab: 0
    }
  },
  mounted: function() {
    this.checkRoute();
  },
  watch: {
    '$route': {
      handler: function(newVal, oldVal) {
        this.checkRoute();
      },
      deep: true
    }
  },
  computed: {
    cdn: function() {
      return this.$root.cdn;
    },
    user: function() {
      return this.$store.getters.user;
    }
  },
  methods: {
    checkRoute: function() {
      if(this.$route.name == 'account') {
        this.$router.replace({name: 'account-trips'});
        return;
      }

      if(this.$route.name == 'account-trips') this.tab = 0;
      if(this.$route.name == 'perks') this.tab = 1;
      if(this.$route.name == 'profile') this.tab = 2;

    }
  }
}
</script>

<style lang="scss" scoped>
  .v-tabs__slider {
    height: 4px;
  }
</style>
